import { render } from "./AllPriceGroupsView.vue?vue&type=template&id=e1e4a4b4"
import script from "./AllPriceGroupsView.vue?vue&type=script&lang=js"
export * from "./AllPriceGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__